import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { Player } from 'ThreeTerminal_mobile_dynamic';
import styles from './index.css';

class VideoArea extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        videoHeight: '',
        boxPaddingTop: '',
    };

    playerBox = React.createRef();

    componentDidMount() {
        window.addEventListener('resize', () => {
            this.setVideoHeight();
        });
        this.setVideoHeight();

        if (window.screen.width > 600) {
            this.setState({
                boxPaddingTop: '7.68',
            });
        }
    }

    setVideoHeight = () => {
        const videoHeight = parseInt((this.playerBox.current.offsetWidth * 388) / 690);

        this.setState({
            videoHeight,
        });
    };

    render() {
        const { content } = this.props;
        const { videoHeight, boxPaddingTop } = this.state;
        const videoConfig = {
            height: '100%',
            hasMargin: false,
            showTitle: false,
            showPoster: true,
            showController: true,
            // m3u8Play: !location.search.includes('isPreview=1'),
            beforePlayCB: (exposeApis) => {
                exposeApis.play();
                // this.handleVideoPlay();
            },
            cutOffPlay: false, // 是否断流
            // 每次点击播放区域回调
            eachTimeClickPlayer: () => {
                // this.handleUnflod();
            },
        };
        const newVideoInfo = {
            ...content.videoInfo,
            callAppConfig: {
                docType: 'phtvsolenewslist',
                pid: content.columnId,
                videoId: content.base62Id,
                noKindFrom: 1,
                kind: 'inter_fhwslmsp01',
                year: content.currentYear,
            },
        };

        return (
            <div>
                <div className={styles.videoAreaBox} ref={this.playerBox}>
                    <img src={content.bannerImg} className={styles.bannerImg} />
                    <div className={styles.playerBox} style={{ height: `${videoHeight}px` }}>
                        <Player videoConfig={{ ...newVideoInfo }} playermsg={videoConfig} />
                    </div>
                </div>
                <div className={styles.videoInfo}>
                    <div className={styles.videoTitle}>{content.pageTitle}</div>
                    <div className={styles.videoBref}>{content.pageBref}</div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(VideoArea);
